import { render } from "./IconList.vue?vue&type=template&id=5ce13062"
import script from "./IconList.vue?vue&type=script&lang=js"
export * from "./IconList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__